import script from "./HotelsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelsInfo.vue?vue&type=script&setup=true&lang=js"

import "./HotelsInfo.vue?vue&type=style&index=0&id=b2e5b1a2&lang=scss"

const __exports__ = script;

export default __exports__